import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AccountIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M384 615c79.5 0 150-42 192-103.5-1.5-63-129-99-192-99-64.5 0-190.5 36-192 99 42 61.5 112.5 103.5 192 103.5zM384 160.5c-52.5 0-96 43.5-96 96s43.5 96 96 96 96-43.5 96-96-43.5-96-96-96zM384 64.5c177 0 319.5 142.5 319.5 319.5s-142.5 319.5-319.5 319.5-319.5-142.5-319.5-319.5 142.5-319.5 319.5-319.5z'/> ]
  getViewBox = () => '0 0 768 768'
}
